import React from 'react';
import PropTypes from 'prop-types';
import { Table, Header } from 'semantic-ui-react';
import ContactListRow from './ContactListRow';

const ContactList = props => {
  const {
    auctionContactList,
    onSelectContact,
    hasLocationName,
    pageHeader,
    isAuctionLocationEditor,
  } = props;

  const listRow = ContactListRow(onSelectContact, hasLocationName, isAuctionLocationEditor);

  const headerRow = (
    <Table.Row
      className={hasLocationName ? 'contact-ext-table' : 'contact-table'}
    >
      {hasLocationName && <Table.HeaderCell>Auction Name</Table.HeaderCell>}
      <Table.HeaderCell>Contact Name</Table.HeaderCell>
      <Table.HeaderCell>Title</Table.HeaderCell>
      <Table.HeaderCell>Email</Table.HeaderCell>
      <Table.HeaderCell>Phone</Table.HeaderCell>
      <Table.HeaderCell>Contact Type</Table.HeaderCell>
      <Table.HeaderCell>Guarantee Confirm</Table.HeaderCell>
      <Table.HeaderCell>Guarantee Cancel</Table.HeaderCell>
      <Table.HeaderCell>Returns</Table.HeaderCell>
      <Table.HeaderCell>Veh Not Covered</Table.HeaderCell>
      <Table.HeaderCell />
    </Table.Row>
  );

  return (
    <div>
      <Header>{pageHeader}</Header>
      <div className='contact_table'>
        <Table
          celled
          selectable
          padded
          renderBodyRow={listRow}
          tableData={auctionContactList}
          headerRow={headerRow}
          size='small'
          compact='very'
          style={{ fontSize: '90%' }}
          striped
          className={hasLocationName ? 'contact-ext-table' : 'contact-table'}
        />
      </div>
    </div>
  );
};

ContactList.propTypes = {
  auctionContactList: PropTypes.arrayOf(PropTypes.object),
  onSelectContact: PropTypes.func,
  hasLocationName: PropTypes.bool,
  pageHeader: PropTypes.string,
  isAuctionLocationEditor: PropTypes.bool,
};

ContactList.defaultProps = {
  auctionContactList: [],
  onSelectContact: () => {},
  hasLocationName: false,
  pageHeader: '',
  isAuctionLocationEditor: false,
};

export default ContactList;
